import R from "lodash.random"

var randomWeight = (items, func, total = null) => {
  if (total === null) total = items.reduce((acc, val) => acc + func(val), 0)
  var r = R(1, total)

  for (var g of items) {
    r -= func(g)
    if (r <= 0) return g
  }

  r = R(0, items.length - 1)
  return items[r]
}

export default randomWeight
